import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { SensorDataService } from 'src/app/features/sensor/services/sensor-data.service';
import { SensorActions } from './sensor-actions';

@Injectable()
export class SensorEffects {
  constructor(
    private actions$: Actions,
    private sensorDataService: SensorDataService,
  ) {}

  loadSensorTypes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SensorActions.loadSensorTypes),
      exhaustMap((action) => {
        return this.sensorDataService
          .getSensorTypes(
            JSON.stringify({
              SearchQuery: '',
              GenericSearch: 0,
              IsActive: '1',
              SortColumn: null,
              SortOrder: null,
            }),
            -1,
            -1,
          )
          .pipe(
            map((sensorTypes) => SensorActions.loadSensorTypesSuccess({ sensorTypes })), // Type inferred from service
            catchError((error) => of(SensorActions.loadSensorTypesFailure({ error }))),
          );
      }),
    ),
  );
}
